var _style, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157 145",
    style: {
      enableBackground: "new 0 0 157 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000158006485959508138750000009728186932264694446_);}\r\n\t.st1{fill:#030344;}\r\n\t.st2{fill:#94F956;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 156.4,
    height: 144.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004505176308682513140000017757166424319881381_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000004505176308682513140000017757166424319881381_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.4,122.1L85.8,0L65.4,9l51.6,99.3L156.4,122.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.4,108.3l38.2-75.9L65.4,9L0,122.1L39.4,108.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.4,108.3l-5.8,35.9h89.3l-5.8-35.9H39.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.6,144.2l5.8-35.9L0,122.1L33.6,144.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.8,144.2l33.6-22.1L117,108.3L122.8,144.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmDark);
export default __webpack_public_path__ + "static/media/logoSmDark.7ca40c0232f10aae96ecdb6aca14cc32.svg";
export { ForwardRef as ReactComponent };